export default "__VITE_ASSET__DwN6wF9Y__"